import React, { memo } from 'react';
import Locale from '@active/react-utils/i18n/Locale';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import CurrencyInputFormField from '../../../CurrencyInputFormField';
import { interpolate } from '../../../../../../../../../../shared/utils/commonUtils';

const EcheckItem = ({
  currencyCode, maskedNumber, index, isPrefillValue, id,
}) => {
  return <div className='echeck-item'>
    <Grid container={false} colGap={30} rowGap={10} align='center'>
      <GridItem span={12} spanMd={6} className='echeck-item__number'>
        <span className='cui-mg-r-6'>
          <Locale id='checkout.lib.components.text.accountNumber'/>
        </span>
        <span>
          {interpolate(maskedNumber, { mask: '****' })}
        </span>
      </GridItem>
      <GridItem span={12} spanMd={6} className='echeck-item__amount'>
        <CurrencyInputFormField
          paymentAccountId={id}
          paymentMethodType='ECHECK'
          isPrefillValue={isPrefillValue}
          name={`echeckAmount_${index}`}
          disabled={isPrefillValue}
          code={currencyCode}/>
      </GridItem>
    </Grid>
  </div>;
};

export default memo(EcheckItem);
